import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function OfferSummarySection() {
  return <section className="py-24 bg-mint relative overflow-hidden" data-id="element-317">
      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-318">
        <FadeIn data-id="element-319">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-sage/20" data-id="element-320">
            <div className="bg-forest text-white p-10 md:p-12 text-center relative overflow-hidden" data-id="element-321">
              <div className="absolute inset-0 opacity-10" data-id="element-322">
                <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-sage" data-id="element-323"></div>
                <div className="absolute -bottom-10 -left-10 w-32 h-32 rounded-full bg-gold" data-id="element-324"></div>
              </div>
              <div className="relative z-10" data-id="element-325">
                <span className="inline-block py-1 px-4 rounded-full bg-white/15 text-white/90 font-semibold text-xs tracking-widest mb-4 uppercase" data-id="element-326">
                  Oferta exclusiva
                </span>
                <h2 className="text-3xl md:text-4xl font-bold leading-tight" data-id="element-327">
                  Resumen de tu oferta completa
                </h2>
                <p className="text-white/80 mt-3 text-lg font-light" data-id="element-328">
                  Todo lo que recibís hoy por solo{' '}
                  <span className="font-bold text-gold" data-id="element-329">$6,39 USD</span>
                </p>
              </div>
            </div>

            <div className="p-8 md:p-12" data-id="element-330">
              <div className="space-y-4 mb-10" data-id="element-331">
                {/* Table Rows */}
                <div className="flex justify-between items-center p-4 bg-cream rounded-xl" data-id="element-332">
                  <span className="font-medium text-gray-800" data-id="element-333">
                    Protocolo SOS 72H (producto principal)
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-334">
                    $27 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-white border border-gray-100 rounded-xl" data-id="element-335">
                  <span className="font-medium text-gray-700" data-id="element-336">
                    BONO #1 — Mapa Rápido SOS
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-337">
                    $17 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-cream rounded-xl" data-id="element-338">
                  <span className="font-medium text-gray-700" data-id="element-339">
                    BONO #2 — Checklist Restaurantes
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-340">
                    $17 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-white border border-gray-100 rounded-xl" data-id="element-341">
                  <span className="font-medium text-gray-700" data-id="element-342">
                    BONO #3 — Tracker 72H Claro
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-343">
                    $13 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl mt-6 border-t-2 border-gray-200" data-id="element-344">
                  <span className="font-bold text-gray-800" data-id="element-345">VALOR TOTAL</span>
                  <span className="font-bold text-gray-800" data-id="element-346">$74 USD</span>
                </div>

                <div className="flex justify-between items-center p-6 bg-sage/10 rounded-xl border-2 border-sage" data-id="element-347">
                  <span className="font-bold text-xl text-forest" data-id="element-348">
                    TU INVERSIÓN HOY
                  </span>
                  <span className="font-bold text-3xl text-forest" data-id="element-349">
                    $6,39 USD
                  </span>
                </div>
              </div>

              <div className="text-center max-w-2xl mx-auto" data-id="element-350">
                <h2 className="text-2xl md:text-3xl font-bold text-forest mb-6" data-id="element-351">
                  Todo esto por una fracción de lo que vale.
                </h2>

                <div className="text-gray-600 space-y-4 mb-10 leading-relaxed" data-id="element-352">
                  <p data-id="element-353">
                    Podés seguir intentando "comer bien a ojo" y despertarte
                    mañana con el mismo abdomen tenso y la misma neblina mental.
                  </p>
                  <p data-id="element-354">
                    O podés invertir menos de lo que gastás en un almuerzo de
                    oficina y tener un sistema completo que te dice exactamente
                    qué hacer, cómo medirlo y cómo mantenerlo.
                  </p>
                  <p data-id="element-355">
                    La inflamación no desaparece sola. Pero con el sistema
                    correcto, puede desaparecer en 72 horas.
                  </p>
                  <p className="text-sm font-semibold text-sage bg-sage/10 inline-block px-4 py-2 rounded-lg mt-4" data-id="element-356">
                    Los 3 bonos solo están disponibles en esta página y con esta
                    oferta. No se venden por separado.
                  </p>
                </div>

                <div className="flex flex-col items-center gap-4" data-id="element-357">
                  <Button className="w-full md:w-auto" data-id="element-358" />
                  <p className="text-sm text-gray-500" data-id="element-359">
                    Descarga instantánea en PDF. Acceso de por vida. Sin
                    suscripciones.
                  </p>
                  <button className="text-xs text-gray-400 hover:text-gray-600 underline underline-offset-4 mt-4 transition-colors" data-id="element-360">
                    No gracias, prefiero seguir sintiéndome inflamada y cansada
                    sin un plan claro.
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}